import { BaseEntryBComponent } from '../entry/base-entry.bcomponent';

export class BaseCreateBComponent extends BaseEntryBComponent {
  submittedDoc: any;
}
